// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"RuleBuilderDivider_titleContainer__28Ng-","title":"RuleBuilderDivider_title__2efOG"};